import { render, staticRenderFns } from "./ChipScroll.vue?vue&type=template&id=e5c05eba&scoped=true"
import script from "./ChipScroll.vue?vue&type=script&lang=js"
export * from "./ChipScroll.vue?vue&type=script&lang=js"
import style0 from "./ChipScroll.vue?vue&type=style&index=0&id=e5c05eba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5c05eba",
  null
  
)

export default component.exports